export const boostrapConfig = {
    appId: 1147,
    mode: "",
    env: "production",
    api: {
        url: "https://api.communico.co/v4",
        ssoUrl: 'https://control-us.communico.co/sso/go',
        authentication: {
            key: "6DrdSLMEQ0Aruaonkgoe",
            secret: "lu7ul7EmYdsaexFX5hrL",
        }
    }
};
export const androidStatusBarColor = "#000000";



// WEBPACK FOOTER //
// ./src/config/index.ts